module.exports = __webpack_public_path__ + "assets/img/1930-do.svg";